import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Paper, Typography, Box } from "@material-ui/core";
import { Pie, Bar } from "react-chartjs-2";

import select from "../../utils/select";
import { getDashboard } from "../../reducer/researchTopic/action";
import { TOPIC_STATUS, statusLabel } from "../../constants/topicStatus";

const KpiCard = ({ label, value, color }) => (
  <Paper style={{ padding: 16, textAlign: "center" }}>
    <Typography variant="h4" style={{ color: color || "#2196f3" }}>{value ?? 0}</Typography>
    <Typography variant="body2" color="textSecondary">{label}</Typography>
  </Paper>
);

export default function ResearchTopicDashboard() {
  const dispatch = useDispatch();
  const role = useSelector((s) => select(s, "userReducer", "role"));
  const myProfile = useSelector((s) => {
    const v = select(s, "profileReducer", "detail");
    return v && v.toJS ? v.toJS() : v;
  });
  const dashboard = useSelector((s) => {
    const v = select(s, "researchTopicReducer", "dashboard");
    return v && v.toJS ? v.toJS() : v;
  });

  const isAdmin = role === "sudo-admin";
  useEffect(() => {
    dispatch(getDashboard(isAdmin ? 0 : myProfile?.id || 0));
  }, [dispatch, isAdmin, myProfile]);

  const d = dashboard || {};
  const countByStatus = d.countByStatus || {};
  const countByYear = d.countByYear || {};

  const statusKeys = Object.keys(countByStatus);
  const pieData = {
    labels: statusKeys.map(statusLabel),
    datasets: [{
      data: statusKeys.map((k) => countByStatus[k]),
      backgroundColor: statusKeys.map((k) => (TOPIC_STATUS[k] ? TOPIC_STATUS[k].color : "#9e9e9e")),
    }],
  };
  const yearKeys = Object.keys(countByYear).sort();
  const barData = {
    labels: yearKeys,
    datasets: [{ label: "Số đề tài", data: yearKeys.map((y) => countByYear[y]), backgroundColor: "#2196f3" }],
  };

  return (
    <Box p={1}>
      <Grid container spacing={2}>
        <Grid item xs={6} md={2}><KpiCard label="Tổng tham gia" value={d.totalParticipated} /></Grid>
        <Grid item xs={6} md={2}><KpiCard label="Chủ nhiệm" value={d.totalLed} color="#4caf50" /></Grid>
        <Grid item xs={6} md={2}><KpiCard label="Đang thực hiện" value={d.inProgress} color="#03a9f4" /></Grid>
        <Grid item xs={6} md={3}><KpiCard label="Chờ báo cáo (sắp/quá hạn)" value={d.pendingReport} color="#ff9800" /></Grid>
        <Grid item xs={6} md={3}><KpiCard label="Chờ nghiệm thu" value={d.pendingAcceptance} color="#673ab7" /></Grid>
      </Grid>

      <Grid container spacing={2} style={{ marginTop: 8 }}>
        <Grid item xs={12} md={5}>
          <Paper style={{ padding: 16 }}>
            <Typography variant="subtitle1" gutterBottom>Đề tài theo trạng thái</Typography>
            {statusKeys.length ? <Pie data={pieData} /> : <Typography color="textSecondary">Chưa có dữ liệu</Typography>}
          </Paper>
        </Grid>
        <Grid item xs={12} md={7}>
          <Paper style={{ padding: 16 }}>
            <Typography variant="subtitle1" gutterBottom>Đề tài theo năm</Typography>
            {yearKeys.length ? <Bar data={barData} /> : <Typography color="textSecondary">Chưa có dữ liệu</Typography>}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
